// extracted by mini-css-extract-plugin
export default {"createCategoryModal":"CreateCategory_createCategoryModal__+rV4Z","title":"CreateCategory_title__Zw2zU","label":"CreateCategory_label__L97im","input":"CreateCategory_input__f+JOh"};